import { useEffect } from 'react';
import {
    initialValues,
    isOrbitDefensorConsumidor,
    validationSchema,
} from './formData';
import { useOrbitFormSection } from '../hooks/useOrbitFormSection';
import { OrbitChannelFormProps } from '../sectionProps';

export const useOrbitChannelForm = ({
    onChangeFormik,
    readOnly,
    seedValues,
}: OrbitChannelFormProps) => {
    const { formik } = useOrbitFormSection({
        initialValues,
        validationSchema,
        onChangeFormik,
        readOnly,
        seedValues,
    });

    useEffect(() => {
        if (readOnly || isOrbitDefensorConsumidor(formik.values.orbitChannel)) {
            return;
        }
        if (
            !formik.values.sfcAdmission &&
            !formik.values.correspondenceFiling
        ) {
            return;
        }
        formik.setFieldValue('sfcAdmission', '');
        formik.setFieldValue('correspondenceFiling', '');
    }, [formik.values.orbitChannel, readOnly]);

    return { formik };
};
